import React from 'react';
import { Dialog, IconButton, Paper, withStyles } from '@material-ui/core';
import {BOOKSHARE_OAUTH} from '../../../redux/constants';
import {bookShareLoginV2} from '../../../redux/actions/authentication';
import {bookShareLoginV3} from '../../../redux/actions/authentication';
import { Close } from '@material-ui/icons';
import styles from '../../../styles/importSkill.js';
import Login from '../Auth/Login.jsx';
import axios from 'axios';
import { connect } from 'react-redux';
import { getBookShareIdentity } from '../../../redux/actions';

function BookShareCredentialsLogin({ classes, openLoading, exitFunc, dispatch }) {
    const url = `${BOOKSHARE_OAUTH}?response_type=code&client_id=ut7fvyalnyxkuumeijbm8vx4&redirect_uri=https://platform.objectiveed.com%2Fbookshare%2Flogin&scope=basic&state=something&client_secret`;
    
    React.useEffect(() => {
        let externalPopup = null;
        let timer = null;
        let sent = false;

        const handleMessage = async (event) => {
            if (event.origin === "https://platform.objectiveed.com" && !sent) {
                sent = true;
                console.log(event.data);
                const data = JSON.parse(event.data);
                
                try {
                    // First handle the login
                    if (data.access_token) {
                        await dispatch(bookShareLoginV2(data.access_token, data.expiration));
                    } else {
                        await dispatch(bookShareLoginV3(data.code));
                    }
                    
                    // Get identity after login
                    await dispatch(getBookShareIdentity());
                    
                    // Let the success screen stay visible for a moment
                    await new Promise(resolve => setTimeout(resolve, 2000));
                    
                    // Then close popup and cleanup
                    if (externalPopup) {
                        externalPopup.close();
                    }
                    exitFunc && exitFunc();
                    
                } catch (error) {
                    console.error('Login error:', error);
                }
            }
        };

        const openPopup = () => {
            const left = window.screenX + (window.outerWidth - 500) / 2;
            const top = window.screenY + (window.outerHeight - 500) / 2.5;
            
            externalPopup = window.open(
                url,
                'BookSharePopup',
                `width=500,height=500,left=${left},top=${top},status=yes,toolbar=no,menubar=no,location=no`
            );

            if (externalPopup) {
                externalPopup.focus();
            }

            timer = setInterval(() => {
                if (externalPopup && externalPopup.closed) {
                    cleanup();
                }
            }, 1000);
        };

        const cleanup = () => {
            if (timer) clearInterval(timer);
            window.removeEventListener("message", handleMessage);
            exitFunc && exitFunc();
        };

        window.addEventListener("message", handleMessage, false);
        openPopup();

        return () => {
            cleanup();
            if (externalPopup) {
                externalPopup.close();
            }
        };
    }, [url, dispatch, exitFunc]);

    return (
        <div>
            {/* Commented dialog code preserved for reference */}
            {/*<Dialog open={openLoading} maxWidth='xl'>*/}
            {/*    <Paper className={classes.importLoadingPage}>*/}
            {/*        <IconButton*/}
            {/*            onClick={() => { exitFunc() }}*/}
            {/*            className={classes.exitBookShareIcon}*/}
            {/*            aria-label="close dialog"*/}
            {/*        >*/}
            {/*            <Close />*/}
            {/*        </IconButton>*/}
            {/*        <Login isBookShareLogin={true} />*/}
            {/*    </Paper>*/}
            {/*</Dialog>*/}
        </div>
    );
}

export default connect(null, null)(withStyles(styles)(BookShareCredentialsLogin));